import { useMemo } from 'react'

import FormContextProvider from '@space-shell/common/hooks/useForm/useForm'

import { ExternalLinkModalType } from './enums'
import ExternalLinkModalContent from './externalLinkModalContent'
import type { ExternalLinkFormFields, ExternalLinkModalProps } from './types'

import { formFields } from '../externalLinkForm'

const ExternalLinkModal = (props: ExternalLinkModalProps) => {
  const memoizedFields = useMemo(
    () => ({
      icon: {
        name: formFields.icon.name,
        value: props.selectedLink?.icon ?? formFields.icon.value
      },
      name: {
        name: formFields.name.name,
        value: props.selectedLink?.name ?? formFields.name.value
      },
      url: {
        name: formFields.url.name,
        value: props.selectedLink?.url ?? formFields.url.value
      }
    }),
    [props.selectedLink]
  )

  const type = props.selectedLink ? ExternalLinkModalType.EDIT : ExternalLinkModalType.ADD

  return (
    <FormContextProvider<ExternalLinkFormFields> formFields={memoizedFields}>
      <ExternalLinkModalContent {...props} type={type} />
    </FormContextProvider>
  )
}

export default ExternalLinkModal
